import bannerBgLq from "@circle-assets/images/opt-in/opt-in-banner-bg-lq.webp";
import bannerBg from "@circle-assets/images/opt-in/opt-in-banner-bg.webp";
import { Icon } from "@circle-react-shared/Icon";
import { HelloBar } from "@circle-react-shared/uikit/HelloBar";
import { SanitizeHTMLString } from "@circle-react-shared/uikit/SanitizeContent";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { ABOUT_CIRCLE_V4_PATH } from "../constants";

export interface OptInBarProps {
  ctaExternalUrl?: string;
  isCTAEnabled?: boolean;
  onCTAClick?: () => void;
  onDismiss?: () => void;
  optInCTAContent: string;
  optInText: string;
}

export const OptInBarComponent = ({
  ctaExternalUrl,
  isCTAEnabled = true,
  onCTAClick,
  onDismiss,
  optInCTAContent,
  optInText,
}: OptInBarProps) => {
  const navigate = useNavigate();

  const handleNavigateToV4About = () => {
    if (ctaExternalUrl) {
      window.open(ctaExternalUrl, "_blank", "noopener noreferrer");
      return;
    }

    if (onCTAClick) {
      onCTAClick();
      return;
    }

    void navigate({ to: ABOUT_CIRCLE_V4_PATH });
  };

  return (
    <HelloBar
      className="relative bg-cover"
      style={{
        backgroundImage: `url(${bannerBg}), url(${bannerBgLq}), linear-gradient(to right, #1B2563 0%, #0A0B14 35%, #0A0B14 50%, #7B3030 72%, #BF6040 100%)`,
      }}
    >
      <div className="flex items-center gap-x-2">
        <Typography.LabelSm as="span" color="text-grey-50">
          <SanitizeHTMLString
            as="span"
            content={optInText}
            className="[&_strong]:font-bold"
          />
        </Typography.LabelSm>
        {/** @TODO This should be a Link component so it can be preloaded. */}
        <Button
          variant="circle"
          onClick={handleNavigateToV4About}
          disabled={!isCTAEnabled}
          className="!bg-white !border-white !text-black hover:!bg-white/90 !font-medium"
        >
          {optInCTAContent}
        </Button>
      </div>
      {onDismiss && (
        <Button
          type="button"
          variant="circle-text"
          onClick={onDismiss}
          className="absolute right-5 top-1/2 -translate-y-1/2 !p-2 text-grey-50 hover:text-grey-300"
          aria-label={t("circle_v4.opt_in_banner.dismiss")}
        >
          <Icon type="16-close" size={16} />
        </Button>
      )}
    </HelloBar>
  );
};
